import { render, staticRenderFns } from "./ListagemDocumentos.vue?vue&type=template&id=772f3ddd&scoped=true"
import script from "./ListagemDocumentos.vue?vue&type=script&lang=js"
export * from "./ListagemDocumentos.vue?vue&type=script&lang=js"
import style0 from "./ListagemDocumentos.vue?vue&type=style&index=0&id=772f3ddd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772f3ddd",
  null
  
)

export default component.exports